import React, { useEffect, useState } from 'react';
import AnimateHeight from 'react-animate-height';
import { useTranslation } from 'react-i18next';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useLocation } from 'react-router-dom';
import { TblRouteStore } from '../../../Interfaces/DataBase';
import { toggleSidebar } from '../../../Storage/Redux/slice/themeConfigSlice';
import { IRootState } from '../../../Storage/Redux/store';
import { IconCaretsDown, IconHome } from '../../Icon';
import { IconMenuDashboard } from '../../Icon/Menu';

const Sidebar = (props: { service: string }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { t: translation } = useTranslation();
  const [routes, setRoutes] = useState<TblRouteStore[]>([]);
  const themeConfig = useSelector((state: IRootState) => state.themeConfig);
  const { semidark } = useSelector((state: IRootState) => state.themeConfig);
  const dbRoutes: TblRouteStore[] = useSelector(
    (state: IRootState) => state.routesStore
  );
  const [currentMenu, setCurrentMenu] = useState<string>('');
  const toggleMenu = (value: string) => {
    setCurrentMenu((oldValue) => {
      return oldValue === value ? '' : value;
    });
  };

  useEffect(() => {
    const selector = document.querySelector(
      '.sidebar ul a[href="' + window.location.pathname + '"]'
    );
    if (selector) {
      selector.classList.add('active');
      const ul: any = selector.closest('ul.sub-menu');
      if (ul) {
        let ele: any =
          ul.closest('li.menu').querySelectorAll('.nav-link') || [];
        if (ele.length) {
          ele = ele[0];
          setTimeout(() => {
            ele.click();
          });
        }
      }
    }
  }, []);

  useEffect(() => {
    if (window.innerWidth < 1024 && themeConfig.sidebar) {
      dispatch(toggleSidebar());
    }
  }, [location]);

  useEffect(() => {
    setRoutes(
      dbRoutes.filter((obj) => obj.service! === props.service && obj.menuShow!)
    );
  }, [dbRoutes]);

  return (
    <div className={semidark ? 'dark' : ''}>
      <nav
        className={`sidebar fixed min-h-screen h-full top-0 bottom-0 w-[260px] shadow-[5px_0_25px_0_rgba(94,92,154,0.1)] z-50 translation-all duration-300 ${semidark ? 'text-white-dark' : ''
          }`}
      >
        <div className="bg-white dark:bg-black h-full">
          <div className="flex justify-between items-center px-4 py-3">
            <NavLink to="/" className="main-logo flex items-center shrink-0">
              <img
                className="w-10 flex-none animate-pulse"
                src="/assets/logo/logo.png"
                alt="logo"
              />
              <span className="text-2xl ltr:ml-1.5 rtl:mr-1.5 font-semibold align-middle lg:inline dark:text-white-light">
                {translation('DTH Admin')}
              </span>
            </NavLink>

            <button
              type="button"
              className="collapse-icon w-8 h-8 rounded-full flex items-center hover:bg-gray-500/10 dark:hover:bg-dark-light/10 dark:text-white-light translation duration-300 rtl:rotate-180"
              onClick={() => dispatch(toggleSidebar())}
            >
              <IconCaretsDown className="m-auto rotate-90" />
            </button>
          </div>
          <PerfectScrollbar className="h-[calc(100vh-80px)] relative">
            <ul className="relative font-semibold space-y-0.5 p-4 py-0">
              {routes.some((item) => item.routePath === '/dashboard') ? (
                <li className="menu nav-item">
                  <NavLink to="/dashboard" className="group">
                    <div className="flex items-center">
                      <IconMenuDashboard className="group-hover:!text-primary shrink-0" />
                      <span className="ltr:pl-3 rtl:pr-3 text-slate-100 font-bold">
                        {translation('Dashboard')}
                      </span>
                    </div>
                  </NavLink>
                </li>
              ) : null}

              {routes
                .filter((item) => item.parentRouteId === 0)
                .sort((a, b) => a.sortOrder! - b.sortOrder!)
                .map((item, index) => {
                  return (
                    <React.Fragment key={item.routeId!}>
                      <li className="menu nav-item">
                        <button
                          type="button"
                          className={`${currentMenu === item.routeName ? 'active' : ''} nav-link group w-full bg-white-light/30 dark:bg-dark py-3 px-2 dark:bg-opacity-[0.08]`}
                          onClick={() => toggleMenu(item.routeName!)}
                        >
                          <div className="flex items-center justify-between gap-4">
                            {!!item.routeIcon &&
                              item.routeIcon.toLowerCase() !== 'fahome' ? (
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="group-hover:!text-cyan-300 shrink-0 text-cyan-100"
                                dangerouslySetInnerHTML={{
                                  __html: item.routeIcon!,
                                }}
                              ></svg>
                            ) : (
                              <IconHome className="shrink-0" />
                            )}
                            <p className="uppercase font-bold bg-clip-text text-transparent bg-gradient-to-r from-cyan-500 to-blue-500 text-xs">
                              {translation(item.routeName!)}
                            </p>
                          </div>

                          <div
                            className={`${currentMenu !== item.routeName ? 'rtl:rotate-90 -rotate-90' : ''} text-pink-500 ease-in-out translation duration-300`}
                          >
                            <IconCaretsDown />
                          </div>
                        </button>
                      </li>

                      <AnimateHeight
                        duration={300}
                        height={currentMenu === item.routeName ? 'auto' : 0}
                      >
                        <li className="">
                          <ul>
                            {routes
                              .filter(
                                (obj) => obj.parentRouteId === item.routeId
                              )
                              .sort((a, b) => a.sortOrder! - b.sortOrder!)
                              .map((obj) => (
                                <li key={obj.routeId!} className="nav-item">
                                  <NavLink
                                    to={obj.routePath!}
                                    className="group"
                                  >
                                    <div className="flex items-center ml-4">
                                      <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="group-hover:!text-primary shrink-0"
                                        dangerouslySetInnerHTML={{
                                          __html: obj.routeIcon!,
                                        }}
                                      ></svg>
                                      <span className="ltr:pl-3 rtl:pr-3 text-xs text-slate-300">
                                        {translation(obj.routeName!)}
                                      </span>
                                    </div>
                                  </NavLink>
                                </li>
                              ))}
                          </ul>
                        </li>
                      </AnimateHeight>
                    </React.Fragment>
                  );
                })}
            </ul>
          </PerfectScrollbar>
        </div>
      </nav>
    </div>
  );
};

export default Sidebar;
